module.exports = __webpack_public_path__ + "img/developer_activity.180eded4.svg";